import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import SubscriptionsIcon from "@mui/icons-material/Subscriptions"
import { useState } from "react"
import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
} from "@mui/material"
import PricingTable from "../../../components/PricingTable/PricingTable"
import { useAuth } from "../../../contexts/AuthContext"
import MessageModal from "../../../components/MessageModal"
import { getStripeSubscriptionData } from "../services/profileService"
import useAxiosPrivate from "../../../hooks/useAxiosPrivate"
import { useMutation } from "@tanstack/react-query"

/*
*********************************************
If the user has cancelled their subscription,
but have not deleted their profile, this allows
the user to reactivate a subscription.
*********************************************
*/

export default function ReinstateSubscription() {
    const { auth } = useAuth()
    const axiosPrivate = useAxiosPrivate()
    const [message, setMessage] = useState(null)
    const [priceData, setPriceData] = useState([])
    const [open, setOpen] = useState(false)
    const newSubscriptionMutation = useMutation({
        mutationFn: () =>
            getStripeSubscriptionData({ axiosPrivate, token: auth?.token }),
        onSuccess: (data) => {
            setPriceData(data.price_data)
            setOpen(true)
        },
        onError: (error) => {
            setMessage({
                type: "Unable...",
                text: `Could not get required data from server: ${error}`,
            })
        },
        onSettled: () => {},
    })

    function handleClick() {
        return newSubscriptionMutation.mutate()
    }

    function handleCancel() {
        setOpen(false)
    }

    return (
        <Box>
            <Button
                sx={{
                    width: { xs: "100%", md: "230px" },
                    mt: { xs: 2, sm: 0 },
                    mb: { xs: 2, sm: 0 },
                    ml: { xs: 0, sm: 2 },
                    mr: { xs: 0, sm: 2 },
                }}
                variant="outlined"
                startIcon={
                    !newSubscriptionMutation.isPending ? (
                        <SubscriptionsIcon />
                    ) : (
                        <CircularProgress size={20} />
                    )
                }
                onClick={handleClick}
                disabled={newSubscriptionMutation.isPending}
            >
                NEW SUBSCRIPTION
            </Button>
            <Dialog open={open} onClose={handleCancel}>
                <Box sx={{ p: "2rem" }}>
                    <DialogTitle>Reinstate Subcription</DialogTitle>
                    <DialogActions sx={{ p: 0 }}>
                        <PricingTable
                            subscriptionsData={priceData}
                            loading={newSubscriptionMutation.isPending}
                            token={auth?.token}
                            reinstate={true}
                            handleCancel={handleCancel}
                            disabled={newSubscriptionMutation.isPending}
                        />
                    </DialogActions>
                </Box>
            </Dialog>
            {message && (
                <MessageModal message={message} setMessage={setMessage} />
            )}
        </Box>
    )
}
